import styled from "styled-components";

export const ButtonsContainer = styled.div`
  display: block;
  padding: 20px;
  text-align: center;
`;
